var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-md-4 d-flex flex-column px-0" },
    [
      _c(
        "SalesDashboardCard",
        {
          attrs: {
            title: "Canceled/On Hold",
            "class-card": "",
            "selected-filter": _vm.selectedFilter,
            filters: _vm.filters
          },
          on: { "set-filter": _vm.setFilter }
        },
        [
          _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
            _c("span", {
              staticClass:
                "dashboard-card-icon dashboard-card-icon-canc-on-hold"
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _vm.loading
                ? _c("Loader")
                : _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 d-flex flex-column" }, [
                      _c("span", { staticClass: "job-status" }, [
                        _vm._v("Canceled")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "job-value" }, [
                        _vm._v(_vm._s(_vm.canceled))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 d-flex flex-column" }, [
                      _c("span", { staticClass: "job-status" }, [
                        _vm._v("On hold")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "job-value" }, [
                        _vm._v(_vm._s(_vm.on_hold))
                      ])
                    ])
                  ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "SalesDashboardCard",
        {
          attrs: {
            title: "Jobs for today",
            "with-filters": false,
            "class-card-wrapper": "bg-blue dashboard-blue"
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _vm.loadingInProgress
                ? _c("Loader")
                : _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 d-flex flex-column" }, [
                      _c("span", { staticClass: "in-progress-title" }, [
                        _vm._v("Scheduled jobs")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "in-progress-value" }, [
                        _vm._v(_vm._s(_vm.for_today))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 d-flex flex-column" }, [
                      _c("span", { staticClass: "in-progress-title" }, [
                        _vm._v("Completed jobs")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "in-progress-value" }, [
                        _vm._v(_vm._s(_vm.completed))
                      ])
                    ])
                  ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a796cc04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a796cc04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/CanceledOnHoldJobs.vue
// module id = null
// module chunks = 